// apps/client/src/hooks/pipelineTracker/useTrendsReport.ts
//
// Pipeline Tracker: headline totals over time.
//
// One point per PUBLISHED snapshot. The warehouse also holds superseded
// uploads, so the server filters on exact upload ids rather than grouping by
// date; re-uploading a correction for the same week is the normal workflow and
// a date grouping would double that week.

import { REPORT_CALLABLE, TRENDS_REPORT_ACTION } from './reportContract';
import { useTrackerCall } from './reportCache';

export interface TrendPoint {
  asAtDate: string;
  /** IN-FLIGHT deals, on the Pipeline tab's definition. Not every row. */
  deals: number;
  loanAmountCents: number;
  stages: Record<string, number>;
  /** Blank or unmapped stage, or an active stage contradicted by a terminal date. */
  unclassifiedDeals: number;
  unclassifiedValueCents: number;
}

export type TrendsResult =
  | { status: 'ok'; data: { points: TrendPoint[]; snapshotCount: number }; expectedSnapshots: number }
  | { status: 'no_snapshot' };

export function useTrendsReport(companyId: string | undefined) {
  // Cached for the session (reportCache.ts): the Trends tab and the Board pack ask the same
  // question, and this is the heaviest report the tracker has, so it is asked once.
  const { data, loading, error, refetch } = useTrackerCall<TrendsResult>(
    REPORT_CALLABLE,
    companyId ? { action: TRENDS_REPORT_ACTION, companyId } : null,
    { label: 'PipelineTracker trendsReport', describeError: () => 'Trends could not be loaded.' }
  );
  return { result: data, loading, error, reload: refetch };
}
